import { useEffect } from "react";

import WebViewBridge from "@logics/utils/webViewBridge";

interface UseAttachLinkClickHandlerProps {
  id: string | number;
}

/**
 * 앱 웹뷰에서 링크를 인앱 웹뷰로 오픈할 수 있도록 click 이벤트를 달아주는 훅
 */
export const useAttachLinkClickHandler = ({
  id,
}: UseAttachLinkClickHandlerProps) => {
  useEffect(() => {
    const links = document.querySelectorAll(`.link-${id}`); // NOTE: linkified된 모든 a 태그를 선택

    const handleClickLink = (event: MouseEvent) => {
      if (WebViewBridge.isInAppWebView()) {
        event.preventDefault();

        const target = event.target as HTMLAnchorElement;

        if (target) {
          WebViewBridge.getInstance().triggerOpenLinkWebView(target.href);
        }
      }
    };

    Array.from(links).forEach((link) => {
      link.addEventListener("click", handleClickLink);
    });

    return () => {
      Array.from(links).forEach((link) => {
        link.removeEventListener("click", handleClickLink);
      });
    };
  }, []);
};
